import fr from './fr.json'

const __ = str => {
    return (fr.find(({key})=>key.toLowerCase()==(str||'').toLowerCase())||{trad:str}).trad
}

export default __
